module.exports = __webpack_public_path__ + "static/media/blog11chat.181bfb25.png";